import { isBloggerBusiness } from '../../../../../utils/accessService';
import { buildImageSource, buildImageSourceSet } from '../../../../../utils/buildImageSource';
import { getDomainFromUrl } from '../../../../../utils/getDomainFromUrl/getDomainFromUrl';
import { useTranslation } from '../../../../../utils/useTranslation';
import { IconProduct } from '../../../../icon/IconProduct';
import { Flex } from '../../../../layout/Flex';
import { Image } from '../../../../media/Image';
import { Retry } from '../../../../media/Retry';
import { Price } from '../../../../price/Price';
import { Typography } from '../../../../typography/Typography';
import { ProductMonetizationPlainText } from '../../../ProductMonetizationPlainText/ProductMonetizationPlainText';
import { ProductMediaCover, ProductTextContainer, ProductTitle } from '../../styles';
import { SingleProductCardProps } from './types';

export const SingleProductCard = ({ product, businessType }: SingleProductCardProps) => {
    const t = useTranslation();

    const { priceInfo, content, title, monetizationEnabled, fintechDiscount, personalDiscount } =
        product;
    const media = content[0]?.media;

    const domain = isBloggerBusiness(businessType)
        ? getDomainFromUrl(product.originalUrl)
        : undefined;

    return (
        <>
            {media ? (
                <ProductMediaCover>
                    <Flex alignItems="center" justifyContent="center" backgroundColor="white">
                        <Retry>
                            <Image
                                width="100%"
                                height="100%"
                                src={buildImageSource(media)}
                                srcSet={buildImageSourceSet(media)}
                            />
                        </Retry>
                    </Flex>
                </ProductMediaCover>
            ) : (
                <ProductMediaCover backgroundColor="white">
                    <Flex alignItems="center" justifyContent="center">
                        <IconProduct size={24} color="var(--control-outline-background)" />
                    </Flex>
                </ProductMediaCover>
            )}
            <ProductTextContainer>
                {monetizationEnabled ? (
                    <>
                        <ProductMonetizationPlainText
                            color="white"
                            textTransform="none"
                            pb={0.25}
                        />
                        <ProductTitle>{t(title)}</ProductTitle>
                    </>
                ) : (
                    <Typography
                        variant="caption"
                        width="100%"
                        textTransform="none"
                        textAlign="left"
                        lines={domain ? 1 : 2}
                        noWrap={Boolean(domain)}
                        color="black"
                    >
                        {t(title)}
                    </Typography>
                )}
                <Price
                    priceInfo={priceInfo}
                    fintechDiscount={fintechDiscount}
                    personalDiscount={personalDiscount}
                    variant="caption"
                    color="black"
                    fintechDiscountOptions={{ compact: true }}
                />
                {domain ? (
                    <Typography variant="caption" color="black" textTransform="none">
                        {domain}
                    </Typography>
                ) : null}
            </ProductTextContainer>
        </>
    );
};
